export const isTimeTravelEnvironment = (environment) => environment === 'ephemeral';
export const hasExpired = (environment) => {
    const { cluster, metadata } = environment;
    return isTimeTravelEnvironment(cluster) && metadata.expiresAt < new Date().toISOString();
};
export const getValidEnvironments = (environments) => environments?.filter((env) => !hasExpired(env)) || [];
